<template lang="pug">
  router-view
</template>

<script>
import { EventBus } from '@/library/_event-bus.js';
import config from '@/config';

export default {
  name: 'App',
  components: {},
  computed: {
    whiteLabel() {
      return this.$store.getters.whiteLabel;
    },
    theme() {
      return this.$store.getters.whiteLabel.theme;
    }
  },
  watch: {
    theme(newVal, oldVal) {
      if (this.whiteLabel.mode && this.whiteLabel.theme) {
        $('body').removeClass(oldVal);
        $('body').addClass(newVal);
      }
    }
  },
  mounted() {
    if (this.whiteLabel.mode && this.whiteLabel.theme) {
      $('body').addClass(this.whiteLabel.theme);
    }
    if (config.brand === 'FOTBET') {
      $('body').addClass('colorfb');
    }
  }
};
</script>

<style lang="scss">
@import './assets/app.scss';
</style>
